import { Inject, Injectable } from '@angular/core';
import { StoreService } from '@shared/services/store.service';
import type { Logger } from '@core/model/domain/logger';
import { loggerToken } from '@di/angularProviderMapper';
import { LegacyNavigationFlowHandler } from './legacyNavigationFlowHandler';
import { NavigationFlowStrategy } from './navigationFlowStrategy';
import { NextNavigationFlowHandler } from './nextNavigationFlowHandler';
import { ProcessPage } from './page';

@Injectable({ providedIn: 'root' })
export class NavigationFlowHandler implements NavigationFlowStrategy {
  private legacyNavigationFlowHandler: LegacyNavigationFlowHandler;
  private nextNavigationFlowHandler: NextNavigationFlowHandler;

  constructor(
    private readonly storeService: StoreService,
    @Inject(loggerToken) private logger: Logger
  ) {
    this.legacyNavigationFlowHandler = new LegacyNavigationFlowHandler(this.storeService, this.logger);
    this.nextNavigationFlowHandler = new NextNavigationFlowHandler(this.storeService, this.logger);
  }

  handleProcessNavigation(processPage: ProcessPage) {
    const isWebauthRedirectionGoingToPartner = this.storeService.getVariableOrThrow(
      'IS_WEBAUTH_REDIRECTION_GOING_TO_PARTNER'
    );

    if (!isWebauthRedirectionGoingToPartner) {
      this.legacyNavigationFlowHandler.handleProcessNavigation(processPage);
      return;
    }

    this.nextNavigationFlowHandler.handleProcessNavigation(processPage);
  }

  handleGoBackViaInAppButton() {
    this.logger.logEvent('IN_APP_HEADER_BACK_BUTTON_PUSHED');

    const isWebauthRedirectionGoingToPartner = this.storeService.getVariableOrThrow(
      'IS_WEBAUTH_REDIRECTION_GOING_TO_PARTNER'
    );

    if (!isWebauthRedirectionGoingToPartner) {
      this.legacyNavigationFlowHandler.handleGoBackViaInAppButton();
      return;
    }

    this.nextNavigationFlowHandler.handleGoBackViaInAppButton();
  }

  handlePopstate(event: PopStateEvent): void {
    const isWebauthRedirectionGoingToPartner = this.storeService.getVariableOrThrow(
      'IS_WEBAUTH_REDIRECTION_GOING_TO_PARTNER'
    );

    if (!isWebauthRedirectionGoingToPartner) {
      this.legacyNavigationFlowHandler.handlePopstate();
      return;
    }

    this.nextNavigationFlowHandler.handlePopstate(event);
  }

  /* Only the partner-channel handler ever opens the go-back popin. */
  confirmGoBackToBankChoice(): void {
    this.nextNavigationFlowHandler.confirmGoBackToBankChoice();
  }

  cancelGoBackToBankChoice(): void {
    this.nextNavigationFlowHandler.cancelGoBackToBankChoice();
  }

  /*
    When page is refreshed, Angular performs a replaceState which looks like : 
    {navigationId: 1}. That's an unwanted change, we wan't to keep previous state
  */
  handleProcessPageRefresh() {
    const processPageBeforeRefresh = this.storeService.getVariable('PROCESS_PAGE');
    history.replaceState(processPageBeforeRefresh, '', '/process');
  }
}
